import(/* webpackMode: "eager", webpackExports: ["AllBlogs"] */ "/home/test_user/npc_front/out/websitenextjs/components/comman/AllBlogs.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/test_user/npc_front/out/websitenextjs/components/StudentResources/FullBlog.js");
